import ReactGA from 'react-ga'
import firebase from '../firebase'

class Logger {
    constructor(authStore) {
        this.authStore = authStore
    }
    static userSignedUp(user){
        //GOOGLE ANALYTICS
        ReactGA.set({ userId: user.uid })
        ReactGA.event({
            category: 'userCreatedAnAccount',
            action: 'uid',
            label: user.uid,
        })

        // //INTERCOM
        // let appId = "ih0csult"
        // if(window.location.host!=='tool.pre.do'){
        //     appId = "qgl5k3rq"
        // }      
        // window.Intercom('boot', {
        //     app_id: appId,
        //     email: user.email,
        //     created_at: firebase.database.ServerValue.TIMESTAMP/1000,
        //     name: user.displayName,
        //     user_id: user.uid,
        // })
        //FACEBOOK PIXEL
        window.fbq('track', 'CompleteRegistration') // or 'Lead', see https://developers.facebook.com/docs/ads-for-websites/pixel-events/v2.9

        //BUGSNAG
        if(window.Bugsnag){
            window.Bugsnag.user = {
                id: user.uid,
                name: user.displayName,
                email: user.email,
            }
        }
    }
    static userSignedIn(user){
        //GOOGLE ANALYTICS
        ReactGA.set({ userId: user.uid })
        ReactGA.event({
            category: 'userLoggedIn',
            action: 'uid',
            label: user.uid,
        })

        //INTERCOM
        // window.Intercom('update', {
        //     name: user.displayName,
        //     email: user.email, // Email address
        //     user_id: user.uid,
        //     created_at: firebase.database.ServerValue.TIMESTAMP/1000,
        // })

        //FACEBOOK PIXEL
        window.fbq('trackCustom', 'userSignedIn', {'uid': user.uid})

        //BUGSNAG
        if(window.Bugsnag){
            window.Bugsnag.user = {
                id: user.uid,
                name: user.displayName,
                email: user.email,
            }
        }
    }
    static userLoggedOut(){
        //GOOGLE ANALYTICS
        ReactGA.event({
            category: 'userLoggedOut',
            action: 'nil',
        })

        //INTERCOM
        // window.Intercom("shutdown")

        //FACEBOOK PIXEL
        window.fbq('trackCustom', 'userLoggedOut')
    }
    static trackEvent(eventName, eventKey=null, eventValue=null){
        if(eventKey && eventValue){
            if(typeof eventValue === 'number'){
                eventValue = eventValue.toString()
            }
            if(typeof eventValue !== 'string'){
                eventValue = 'not-string'
            }
            //GOOGLE ANALYTICS
            ReactGA.event({
              category: eventName,
              action: eventKey,
              label: eventValue,
            })

            //INTERCOM
            // window.Intercom('trackEvent', eventName, {eventKey: eventValue})
            // window.Intercom('update')

            //FACEBOOK PIXEL
            window.fbq('trackCustom', eventName, {eventKey: eventValue})

            //BUGSNAG
            if(window.Bugsnag)
                window.Bugsnag.leaveBreadcrumb(eventName, {eventKey: eventValue})
        }else{
            //GOOGLE ANALYTICS
            ReactGA.event({
              category: eventName,
              action: 'nil',
            })

            //INTERCOM
            // window.Intercom('trackEvent', eventName)
            // window.Intercom('update')

            //FACEBOOK PIXEL
            window.fbq('trackCustom', eventName)

            //Bugsnag
            if(window.Bugsnag)
                window.Bugsnag.leaveBreadcrumb(eventName)
        }
    }
    logPageView() {
        ReactGA.set({ page: window.location.pathname + window.location.search })
        ReactGA.pageview(window.location.pathname + window.location.search)
        window.fbq('track', 'PageView')
        // window.Intercom('update')
        if(window.Bugsnag)
            window.Bugsnag.refresh()
    }
}

export default Logger



// WEBPACK FOOTER //
// ./src/stores/Logger.js